module.exports = __webpack_public_path__ + "media/src/assets/images/lps-spending_graph-b4e8167d10c13d066beb6622d51a7a05.png";